import { render } from "./group-page.vue?vue&type=template&id=08651210"
import script from "./group-page.vue?vue&type=script&lang=js"
export * from "./group-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__